import type {
    AuraFilterConflict,
    AuraResponseBlocks,
} from '@/types/models/AuraResponseBlocksModel';
import type { AuraFilters } from '@/types/models/AuraFiltersModel';

export interface AuraAskResponse {
    conversationId: number;
    messageId: number;
    response: AuraResponseBlocks;
    metadata: {
        processingTime: number;
        tokensUsed: number;
        model: string;
        filters: AuraFilters | null;
        context: Record<string, unknown> | null;
        filterResolution?: {
            source: 'request' | 'question' | null;
            requestDateWindow: {
                dateFrom: string | null;
                dateTo: string | null;
            } | null;
            questionDateWindow: {
                dateFrom: string | null;
                dateTo: string | null;
            } | null;
            effectiveDateWindow: {
                dateFrom: string | null;
                dateTo: string | null;
            } | null;
            questionPeriod: {
                period: string;
                original: string;
            } | null;
        } | null;
        classification?: {
            mode?: string;
            intent?: string;
            entities?: {
                metrics?: string[];
                dimensions?: string[];
                period?: string | null;
                top?: unknown;
                filters?: Record<string, unknown>;
                callIds?: Array<string | number>;
            };
            confidence?: number;
            filter_conflict?: AuraFilterConflict | null;
            time_coherent?: boolean;
            time_conflict?: {
                questionPeriod?: string | null;
                filterPeriod?: string | null;
                details?: string | null;
            } | null;
        };
    };
}
